import i18n from 'src/i18n';
import { http, sendMessageToApp } from 'services/http';

const patientActionTypes = {
  PATIENT_LOAD_SUCCESS: 'PATIENT_LOAD_SUCCESS',
  PATIENT_LOAD_ERROR: 'PATIENT_LOAD_ERROR',
  CHANGE_LANGUAGE_SUCCESS: 'CHANGE_LANGUAGE_SUCCESS',
  CHANGE_LANGUAGE_ERROR: 'CHANGE_LANGUAGE_ERROR',
  SET_RESERVATION_DATA: 'SET_RESERVATION_DATA',
  USER_SET_VALIDATION_STATUS: 'USER_SET_VALIDATION_STATUS'
};

//──── Get patient info ──────────────────────────────────────────────────────────────────
export const loadPatientData = cb => dispatch => {
  http
    .get('patients/me')
    .then(({ data }) => {
      dispatch(setPatientDataSuccess(data));
      i18n.changeLanguage(data.language || 'nl');
      sendMessageToApp({ actionName: 'userDataLoaded' });
      cb && cb(data);
    })
    .catch(err => {
      sendMessageToApp({
        actionName: 'userDataLoadedError',
        mes: err.message,
        res: err.response
      });
      dispatch(patientLoadErrors());
      cb && cb(err);
    });
};

export const setPatientDataSuccess = data => ({
  type: patientActionTypes.PATIENT_LOAD_SUCCESS,
  payload: data
});

const patientLoadErrors = () => ({
  type: patientActionTypes.PATIENT_LOAD_ERROR,
  payload: null
});

//──── Change language ───────────────────────────────────────────────────────────────────
export const changeLanguage = language => dispatch => {
  const body = [
    {
      path: '/Language',
      op: 'replace',
      value: language.value
    }
  ];

  http
    .patch('patients/me', body)
    .then(({ data }) => {
      i18n.changeLanguage(language.value);
      dispatch(changeLanguageSuccess(data));
    })
    .catch(() => {
      dispatch(changeLanguageError());
    });
};

const changeLanguageSuccess = data => ({
  type: patientActionTypes.CHANGE_LANGUAGE_SUCCESS,
  payload: data
});

const changeLanguageError = () => ({
  type: patientActionTypes.CHANGE_LANGUAGE_ERROR
});

//────  ──────────────────────────────────────────────────────────────────────────────────

export const setUserValidationStatus = status => ({
  type: patientActionTypes.USER_SET_VALIDATION_STATUS,
  payload: status
});

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case patientActionTypes.PATIENT_LOAD_SUCCESS: {
      return { ...state, ...action.payload };
    }
    case patientActionTypes.PATIENT_LOAD_ERROR:
      return {};
    case patientActionTypes.CHANGE_LANGUAGE_SUCCESS:
      return { ...state, language: action.payload };
    case patientActionTypes.CHANGE_LANGUAGE_ERROR:
      return { ...state, language: {} };
    case patientActionTypes.SET_RESERVATION_DATA:
      return {
        ...state,
        reservationData: Object.assign({}, state.reservationData, action.payload)
      };
    case patientActionTypes.USER_SET_VALIDATION_STATUS: {
      if (state) {
        const userData = state;

        userData.status = action.payload;
        return { ...state, ...userData };
      }
      return state;
    }
    default:
      return state;
  }
};
